import { render } from "./EventCreate.vue?vue&type=template&id=c88150d4"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"

import "./EventCreate.vue?vue&type=style&index=0&id=c88150d4&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__